function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from 'react';
import { flexSpotSettings } from '../prop-types';
import FooterComponent from './FooterComponent';
import FoldOutComponent from './FoldOutComponent';
import { withReactBootstrap } from '@demant/react-bootstrap';
import { onResize } from '@demant/wdh';
var SliderSectionComponent = function SliderSectionComponent(_ref) {
  var settings = _ref.settings,
    footerData = _ref.footerData,
    isDesktop = _ref.isDesktop;
  var slidingImageEl = useRef(null);
  var _useState = useState('0px'),
    _useState2 = _slicedToArray(_useState, 2),
    sliderPos = _useState2[0],
    setSliderPos = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    dragged = _useState4[0],
    setDragged = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    clipPath = _useState6[0],
    setClipPath = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showFoldOut = _useState8[0],
    setShowFoldout = _useState8[1];
  var _useState9 = useState('slider-section'),
    _useState0 = _slicedToArray(_useState9, 2),
    sectionId = _useState0[0],
    setSectionId = _useState0[1];
  useEffect(function () {
    onResize(function () {
      setSliderPos("".concat(slidingImageEl.current.offsetWidth / 2, "px"));
    });
  }, []);
  useEffect(function () {
    var tmp = {
      // clipPath: `inset(0px 0px 0px ${sliderPos})`,
      clip: "rect(auto, auto, auto, ".concat(sliderPos, ")")
    };
    setClipPath(tmp);
  }, [sliderPos]);
  useEffect(function () {
    setSliderPos("".concat(slidingImageEl.current.offsetWidth / 2, "px"));
  }, [slidingImageEl]);
  var renderHTMLFromItem = function renderHTMLFromItem(item) {
    return /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: item.html.html
      }
    });
  };
  var onDiscoverMore = function onDiscoverMore() {
    setShowFoldout(!showFoldOut);
  };
  var items = {
    headlineItem: null,
    leftTextitem: null,
    rightTextItem: null,
    imageOldWorldDesktopItem: null,
    imageOldWorldMobileItem: null,
    imageNewWorldDesktopItem: null,
    imageNewWorldMobileItem: null,
    videoItem: null
  };
  settings.preElementItems.forEach(function (item) {
    switch (item.type) {
      case 'text':
        if (!items.headlineItem) items.headlineItem = item;else if (!items.leftTextitem) items.leftTextitem = item;else if (!items.rightTextItem) items.rightTextItem = item;
        break;
      case 'video':
        items.videoItem = item;
        break;
      case 'image':
        if (item.classes.indexOf('element__item__image--large') > -1) {
          if (!items.imageOldWorldDesktopItem) items.imageOldWorldDesktopItem = item;else if (!items.imageNewWorldDesktopItem) items.imageNewWorldDesktopItem = item;
        }
        if (item.classes.indexOf('element__item__image--small') > -1) {
          if (!items.imageOldWorldMobileItem) items.imageOldWorldMobileItem = item;else if (!items.imageNewWorldMobileItem) items.imageNewWorldMobileItem = item;
        }
        break;
    }
  });
  var headlineItem = items.headlineItem,
    leftTextitem = items.leftTextitem,
    rightTextItem = items.rightTextItem,
    imageOldWorldDesktopItem = items.imageOldWorldDesktopItem,
    imageOldWorldMobileItem = items.imageOldWorldMobileItem,
    imageNewWorldDesktopItem = items.imageNewWorldDesktopItem,
    imageNewWorldMobileItem = items.imageNewWorldMobileItem,
    videoItem = items.videoItem;
  var updateSliderPos = function updateSliderPos(evt) {
    var rect = evt.target.getBoundingClientRect();
    var clientX = evt.clientX || evt.touches && evt.touches.length && evt.touches[0].clientX;
    var x = clientX - rect.left; // x position within the element.

    setSliderPos("".concat(x, "px"));
  };
  var onSliderMouseDown = function onSliderMouseDown(evt) {
    setDragged(evt.target);
    updateSliderPos(evt);
  };
  var onSliderMouseMove = function onSliderMouseMove(evt) {
    if (dragged) {
      evt.preventDefault();
      updateSliderPos(evt);
    }
  };
  var onSliderMouseUp = function onSliderMouseUp() {
    setDragged(null);
  };
  var ontouch = function ontouch(e) {
    console.log('ontouch');
    console.log(e);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, headlineItem && /*#__PURE__*/React.createElement("div", {
    className: "headlines"
  }, renderHTMLFromItem(headlineItem)), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, isDesktop && leftTextitem && /*#__PURE__*/React.createElement("div", {
    className: "content-label"
  }, renderHTMLFromItem(leftTextitem)), !isDesktop && /*#__PURE__*/React.createElement("div", {
    className: "content-labels"
  }, leftTextitem && /*#__PURE__*/React.createElement("div", {
    className: "content-label"
  }, renderHTMLFromItem(leftTextitem)), rightTextItem && /*#__PURE__*/React.createElement("div", {
    className: "content-label"
  }, renderHTMLFromItem(rightTextItem))), /*#__PURE__*/React.createElement("div", {
    className: "slider-content",
    onMouseMove: onSliderMouseMove,
    onMouseDown: onSliderMouseDown,
    onMouseUp: onSliderMouseUp,
    onMouseOut: onSliderMouseUp,
    onMouseLeave: onSliderMouseUp,
    onTouchStart: onSliderMouseDown,
    onTouchMove: onSliderMouseMove,
    onTouchCancel: onSliderMouseUp,
    onTouchEnd: onSliderMouseUp,
    role: "presentation",
    onBlur: onSliderMouseUp
  }, /*#__PURE__*/React.createElement("div", {
    className: "slider-images"
  }, imageOldWorldDesktopItem && /*#__PURE__*/React.createElement("div", {
    className: "slider-image"
  }, /*#__PURE__*/React.createElement("img", {
    src: imageOldWorldDesktopItem.image.src,
    alt: imageOldWorldDesktopItem.image.alt
  })), imageNewWorldDesktopItem && /*#__PURE__*/React.createElement("div", {
    className: "slider-image",
    style: clipPath,
    ref: slidingImageEl
  }, /*#__PURE__*/React.createElement("img", {
    src: imageNewWorldDesktopItem.image.src,
    alt: imageNewWorldDesktopItem.image.alt
  }))), /*#__PURE__*/React.createElement("div", {
    className: "slider",
    style: {
      left: sliderPos
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "slider-track"
  }), /*#__PURE__*/React.createElement("div", {
    className: "slider-thumb"
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null)))), isDesktop && rightTextItem && /*#__PURE__*/React.createElement("div", {
    className: "content-label"
  }, renderHTMLFromItem(rightTextItem))), /*#__PURE__*/React.createElement(FooterComponent, {
    footerData: footerData,
    videoIframe: videoItem ? videoItem.html.html : '',
    onDiscoverMore: onDiscoverMore,
    isFoldOut: showFoldOut,
    randomNumber: sectionId,
    isFoldOutContent: settings.elements.length > 0
  }), /*#__PURE__*/React.createElement(FoldOutComponent, {
    elements: settings.elements,
    show: showFoldOut,
    randomNumber: sectionId,
    onDiscoverMore: onDiscoverMore,
    footerData: footerData[0]
  }));
};
SliderSectionComponent.propTypes = {
  settings: flexSpotSettings.isRequired
};
export default withReactBootstrap(SliderSectionComponent);